import { render, staticRenderFns } from "./vehicleinspectionviewdetails.vue?vue&type=template&id=0f95ea9c&scoped=true"
import script from "./vehicleinspectionviewdetails.vue?vue&type=script&lang=js"
export * from "./vehicleinspectionviewdetails.vue?vue&type=script&lang=js"
import style0 from "./vehicleinspectionviewdetails.vue?vue&type=style&index=0&id=0f95ea9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95ea9c",
  null
  
)

export default component.exports